/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { IHorario, ITotais } from 'Models/docas'
import { IAgendaAction } from 'Models/docas'
import IAgendamentoModoCompacto from 'Models/docas/IAgendamentoModoCompacto'
import IAgendaSimplificada from 'Models/docas/IAgendaSimplificada'
import IFormAgendamentoBiomassa from 'Models/docas/IFormAgendamentoBiomassa'
import IFormDocasBucasPorPlacaFilter from 'Models/docas/IFormDocasBuscaPorPlacaFilter'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'

import {
  ServiceDocasResponse,
  ServiceUpdateResponse,
} from './../../Types/ServiceResponse'

const agenda = {
  getList: async (idComponente: number, cdArmazem: number, data: string) => {
    const result: AxiosResponse<ServiceListResponse<IHorario, ITotais>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IHorario, ITotais>
      >(`${hosts.WS_DOCAS}/agenda?cdArmazem=${cdArmazem}&data=${data}`)

    return result
  },

  getAgendaSimplificada: async (
    idComponente: number,
    cdArmazemConfig: number,
    data: string,
  ) => {
    const result: AxiosResponse<ServiceListResponse<IAgendaSimplificada>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IHorario, ITotais>
      >(
        `${hosts.WS_DOCAS}/agenda_simplificada?cdArmazemConfig=${cdArmazemConfig}&data=${data}`,
      )

    return result
  },

  getAgendaModoCompacto: async (
    idComponente: number,
    cdArmazem: number,
    data: string,
  ) => {
    const result: AxiosResponse<ServiceListResponse<IAgendamentoModoCompacto>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IAgendamentoModoCompacto>
      >(
        `${hosts.WS_DOCAS}/agenda_modo_compacto?cdArmazem=${cdArmazem}&data=${data}`,
      )

    return result
  },

  getDetalhes: async (idComponente: number, cdHorario: number) => {
    const result: AxiosResponse<ServiceListResponse<IHorario>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IHorario>>(
        `${hosts.WS_DOCAS}/agenda/${cdHorario}`,
      )

    return result
  },

  executaAcao: async (idComponente: number, data: IAgendaAction[]) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/agenda`, data)

    return result
  },

  liberarAgenda: async (
    idComponente: number,
    cdArmazem: number,
    data: string,
  ) => {
    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).post<ServiceListResponse>(`${hosts.WS_DOCAS}/agenda`, {
      cdArmazem,
      data,
    })

    return result
  },

  liberaAgendaTodosArmazens: async (
    idComponente: number,
    dataInicial: moment.Moment,
    dataFinal: moment.Moment,
  ) => {
    const bodyRequisicao = {
      dataInicial: dataInicial.format('YYYY-MM-DD'),
      dataFinal: dataFinal.format('YYYY-MM-DD'),
    }

    const resultado: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).post<ServiceListResponse>(
      `${hosts.WS_DOCAS}/agenda_periodo_geral`,
      bodyRequisicao,
    )

    return resultado
  },

  getAtualizacoes: async (
    idComponente: number,
    CdArmazem: number,
    DataUltBusca: string,
    DataAgenda: string,
  ) => {
    const result: AxiosResponse<ServiceDocasResponse> = await ApiService({
      idComponente,
    }).get<ServiceDocasResponse>(
      `${hosts.WS_DOCAS}/atualizacoes?CdArmazem=${CdArmazem}&DataAgenda=${DataAgenda}`,
    )

    return result
  },

  bloqueiaAgendaByArmazem: async (
    idComponente: number,
    dataInicio: string,
    dataFim: string,
    cdArmazem: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/agenda_bloqueio_armazem`, {
      cdArmazem,
      dataInicio,
      dataFim,
    })

    return result
  },

  bloqueiaAgendaByDoca: async (
    idComponente: number,
    dataInicio: string,
    dataFim: string,
    cdDoca: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/agenda_bloqueio_doca`, {
      cdDoca,
      dataInicio,
      dataFim,
    })

    return result
  },

  bloqueiaAgendaByJanela: async (
    idComponente: number,
    dataInicio: string,
    dataFim: string,
    cdJanela: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/agenda_bloqueio_janela`, {
      cdJanela,
      dataInicio,
      dataFim,
    })

    return result
  },

  agendaTrocaHorario: async (
    idComponente: number,
    cdAgendamentoDocasHorarioOrigem: number[],
    cdAgendamentoDocasHorarioDestino: number[],
    justificativa: string,
    placaVeiculo: string,
    transportadora: string,
    cdEntidade: number,
    cdVeiculo: number,
    agendamentoMultiplo: boolean,
    qtdJanelas: number,
    tamanhoJanela: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/agenda_troca`, {
      cdAgendamentoDocasHorarioOrigem,
      cdAgendamentoDocasHorarioDestino,
      justificativa,
      placaVeiculo,
      transportadora,
      cdEntidade,
      cdVeiculo,
      agendamentoMultiplo,
      qtdJanelas,
      tamanhoJanela,
    })

    return result
  },

  pesquisaPorPlaca: async (
    idComponente: number,
    filter?: IFormDocasBucasPorPlacaFilter,
  ) => {
    let localFilters: IFormDocasBucasPorPlacaFilter | undefined

    if (filter) {
      localFilters = filter
    }

    const result: AxiosResponse<ServiceListResponse<IHorario>> =
      await ApiService({
        idComponente,
      }).get<ServiceListResponse<IHorario>>(
        QueryStringFilter(`${hosts.WS_DOCAS}/agenda_placa`, localFilters),
      )

    return result
  },
}

export default agenda
